import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type AppSettingsState = {
  home: string
}

const initialState: AppSettingsState = {
  home: '',
}

const slice = createSlice({
  name: 'appSettings',
  initialState,
  reducers: {
    setHome: (state, { payload: home }: PayloadAction<string>) => {
      state.home = home
    },
  },
})

export const { setHome } = slice.actions

export const appSettingsReducer = slice.reducer
